import {
  useCreateFormDataMutation,
  useGetFormLibraryMutation,
  useSelecteFeasibilityFormDataMutation,
  useUpdateFeasibilityFormDataMutation
} from 'src/services/feasibility';

export const useFeasibilityForms = () => {
  const [
    createFeasibilityFromDataFunc,
    {
      data: createFeasibilityFromData,
      isError: createFeasibilityFromDataIsError,
      isSuccess: createFeasibilityFromDataIsSuccess,
      isLoading: createFeasibilityFromDataIsLoading,
      error: createFeasibilityFromDataError
    }
  ] = useCreateFormDataMutation();

  const [
    selectFeasibilityFromDataFunc,
    {
      data: selectFeasibilityFromData,
      isError: selectFeasibilityFromDataIsError,
      isSuccess: selectFeasibilityFromDataIsSuccess,
      isLoading: selectFeasibilityFromDataIsLoading,
      error: selectFeasibilityFromDataError
    }
  ] = useSelecteFeasibilityFormDataMutation();

  const [
    updateFeasibilityFormDataFunc,
    {
      data: updateFeasibilityFormData,
      isError: updateFeasibilityFormDataIsError,
      isSuccess: updateFeasibilityFormDataIsSuccess,
      isLoading: updateFeasibilityFormDataIsLoading,
      error: updateFeasibilityFormDataError
    }
  ] = useUpdateFeasibilityFormDataMutation();

  const [getFormLibrary, { data: formData, isLoading: getFormLoading }] = useGetFormLibraryMutation();

  return {
    createFeasibilityFromDataFunc,
    createFeasibilityFromData,
    createFeasibilityFromDataIsError,
    createFeasibilityFromDataIsSuccess,
    createFeasibilityFromDataIsLoading,
    createFeasibilityFromDataError,
    selectFeasibilityFromDataFunc,
    selectFeasibilityFromData,
    selectFeasibilityFromDataIsError,
    selectFeasibilityFromDataIsSuccess,
    selectFeasibilityFromDataIsLoading,
    selectFeasibilityFromDataError,
    updateFeasibilityFormDataFunc,
    updateFeasibilityFormData,
    updateFeasibilityFormDataIsError,
    updateFeasibilityFormDataIsSuccess,
    updateFeasibilityFormDataIsLoading,
    updateFeasibilityFormDataError,
    getFormLibrary,
    formData,
    getFormLoading
  };
};
